import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = ({ className = '' }) => {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith('en') ? 'en' : 'de';

  const setLang = (lang) => {
    i18n.changeLanguage(lang);
    try {
      localStorage.setItem('lang', lang);
    } catch {
      // ignore
    }
  };

  return (
    <div
      className={`inline-flex items-center rounded-full border border-slate-300 bg-white/80 backdrop-blur-sm text-xs font-semibold overflow-hidden ${className}`}
      data-testid="language-switcher"
    >
      <button
        type="button"
        onClick={() => setLang('de')}
        className={`px-2.5 py-1 transition-colors ${current === 'de' ? 'bg-slate-800 text-white' : 'text-slate-600 hover:bg-slate-100'}`}
        data-testid="lang-de-btn"
      >
        DE
      </button>
      <button
        type="button"
        onClick={() => setLang('en')}
        className={`px-2.5 py-1 transition-colors ${current === 'en' ? 'bg-slate-800 text-white' : 'text-slate-600 hover:bg-slate-100'}`}
        data-testid="lang-en-btn"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
